export default __webpack_public_path__ + "static/media/SCAN_LOCATION.0e7a273c.svg";